import { AlertBox } from '@spotahome/ui-library';

import { trans } from '@spotahome/soyuz/client';

import './BookingBarNotAvailable.scss';

const BookingBarNotAvailable = () => (
  <div className="booking-bar-not-available">
    <AlertBox
      message={trans('listing.book-now-not-available.alertbox-message')}
      roundedCorners
    />
  </div>
);

export default BookingBarNotAvailable;
